import React, {Component} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Loader } from '../PageTemplate';


export class PrivateRoute extends Component {

    showLoadingMessage() {
        // wating for process end (equal false)
        if(this.props.waitForProcess !== false) {
            return (
                <Loader />
            )
        }
    }

    showRoutePage() {
        const PrivateComponent = this.props.component;
        if(this.props.waitForProcess !== false) return;

        if(this.props.loggedIn === true && PrivateComponent) return (
            <PrivateComponent />
        )
    }

    redirectToLoginPage() {
        if(this.props.waitForProcess !== false || this.props.loggedIn === true) return;

        return (
            <Redirect to={{ pathname: '/login', state: { from: this.props.location } }} />
        )
    }

    render () {
        const {path, render} = this.props
        return (
            <Route path={path}>
                {
                    render || 
                    this.showRoutePage()
                    || this.showLoadingMessage() 
                    || this.redirectToLoginPage()
                }
            </Route>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/App/PrivateRoute.jsx